import {createGrid} from "../../../helpers/grids/grids";
import {createCellRenderer, createDoubleClickHandler} from "../../../helpers/grids/helpers";

/**
 * Shared by cast and crew index views
 */
function initProductionDirectorPageView() {
	createGrid('.audition-requests-grid', {
			columnDefs: [
				{
					headerName: 'First Name',
					field: 'first_name',
					width: 100,
					sortable: true,
					cellRenderer: createCellRenderer((params) => {
						let firstName = params.data.first_name;

						if (firstName.length > 20) {
							firstName = firstName.substring(0, 20) + "...";
						}

						return `<div title="${params.data.first_name}">${firstName}</div>`
					}),
				},
				{
					headerName: 'Last Name',
					field: 'last_name',
					width: 100,
					sortable: true,
					cellRenderer: createCellRenderer((params) => {
						let lastName = params.data.last_name;

						if (lastName.length > 20) {
							lastName = lastName.substring(0, 20) + "...";
						}

						return `<div title="${params.data.last_name}">${lastName}</div>`
					}),
				},
				{
					headerName: 'Auditioned For',
					field: 'roles_string',
					flex: 1,
					cellRenderer: createCellRenderer((params) => {
						// noinspection JSUnresolvedReference
						const rolesHtml = params.data.roles_string.split(',').join("<br>");

						return `<div style="line-height: 1.4">${rolesHtml}</div>`
					}),
				},
				{
					headerName: 'Conflicts',
					field: 'conflicts_string',
					cellRenderer: createCellRenderer((params) => {
						// nl to br
						// noinspection JSUnresolvedReference
						let string = params.data.conflicts_string.split("\n").join("<br>");
						// tab to html tab
						string = string.replaceAll("\t", "&nbsp&nbsp&nbsp&nbsp");
						return `<div style="line-height: 1.4">${string}</div>`
					})
				},
			],
			paginationPageSize: 500,
			cacheBlockSize: 500,
			_rowName: 'Auditions',
			rowClass: 'cursor-pointer',
			onRowDoubleClicked: createDoubleClickHandler(data => {
				// noinspection JSUnresolvedVariable
				window.open(data.view_url, 'blank');
			}),
			getRowHeight: (params) => {
				// noinspection JSUnresolvedReference
				const auditionedRoles = params.data.roles_string.split(',');
				// noinspection JSUnresolvedReference
				const conflicts = params.data.conflicts_string.split("\n");

				const minSize = 40;

				// 16px per auditioned role + 30px for each 10 row of roles
				const sizeFromRolesString = (auditionedRoles.length * 16) + (auditionedRoles.length / 10 * 30);

				// 16px per auditioned role + 30px for each 10 row of conflicts
				const sizeFromConflictsString = (conflicts.length * 16) + (conflicts.length / 10 * 30);

				// Use largest column cell to calculate extra row height
				let extraRowHeight;
				if (sizeFromRolesString > sizeFromConflictsString) {
					extraRowHeight = sizeFromRolesString;
				} else {
					extraRowHeight = sizeFromConflictsString;
				}

				return minSize + extraRowHeight
			},
		},
		window['routes/admin.productions.audition-requests.grid'],
		() => {
			return {}
		}
	);


	/** Methods */


}

export {
	initProductionDirectorPageView
}
